// Mirrors the TriageState enum in packages/database/prisma/schema.prisma and
// the JobStatus shape returned by solvtax-api's GET /api/v1/triage/:id.
// Keep this list in sync with the backend enum; it is not generated.
export const TRIAGE_STATES = [
  "PENDING_INGESTION",
  "EXTRACTING",
  "AUDITING",
  "AWAITING_ACCOUNT",
  "READY_FOR_APPEAL",
  "FILED",
  "FAILED",
];

export const TERMINAL_TRIAGE_STATES = ["FILED", "FAILED"];

export const isTerminalTriageState = (state) => TERMINAL_TRIAGE_STATES.includes(state);

// UI copy + step order for the non-terminal happy path. FAILED is rendered
// separately as an error state rather than a step in the progress list.
export const TRIAGE_STATE_META = {
  PENDING_INGESTION: {
    label: "PENDING_INGESTION",
    terminalLine: "Verifying uploaded documents...",
    description: "Reading county notice and equipment asset ledger.",
  },
  EXTRACTING: {
    label: "EXTRACTING",
    terminalLine: "AI Extraction Engine processing asset profiles...",
    description: "Parsing notice fields and normalizing asset records.",
  },
  AUDITING: {
    label: "AUDITING",
    terminalLine: "Cross-referencing state depreciation schedules...",
    description: "Running depreciation audit against county assessed value.",
  },
  AWAITING_ACCOUNT: {
    label: "AWAITING_ACCOUNT",
    terminalLine: "Audit complete. Potential overcharges identified.",
    description: "Review your savings preview and request your verified report.",
  },
  READY_FOR_APPEAL: {
    label: "READY_FOR_APPEAL",
    terminalLine: "Filing compiled. Evidence package ready.",
    description: "Appeal packet assembled. Auto-filing in progress.",
  },
  FILED: {
    label: "FILED",
    terminalLine: "Filing compiled. Evidence package ready.",
    description: "Appeal filed. Evidence artifacts available for download.",
  },
  FAILED: {
    label: "FAILED",
    terminalLine: "Audit paused.",
    description: "Something stopped this filing from completing.",
  },
};

export const TRIAGE_PROGRESS_STATES = TRIAGE_STATES.filter((s) => s !== "FAILED");

export const triageStateIndex = (state) => TRIAGE_PROGRESS_STATES.indexOf(state);
